<template>
  <div>
    <van-popup :close-on-click-overlay="false" round v-model="show" :style="{ width: '90%',backgroundColor:'#eae9e9'}">
      <van-nav-bar title="新增票据" left-text="取消" right-text="保存并关闭" @click-left="close"
                   @click-right="relativeFlowPopupSubmit"/>
      <div style="overflow-y: auto" class="h-vh-70">
        <van-uploader v-if="!file" v-model="imageFileList" accept=".pdf"  :preview-image="false"
                      :after-read="(file) => {afterAddFile(file)}" :before-read="beforeRead"  class="Muploader"
                      :preview-full-image="false">
          <div style="width: 90vw" class="bg-FF p-70 text-center h-vh-20">
            <div>
              <van-icon size="50" color="#ccc" name="upgrade"/>
              <div class="font-40 cor-CC">上传发票</div>
            </div>
          </div>
        </van-uploader>

      <div v-if="file" class="pdfBox">
        <PdfPreview  ref="PdfPreview"  :pdf-url="pdfSrc" />
      </div>

        <van-form ref="form" :show-error="false" error-message-align="right">
          <!-- 原有表单内容不变 -->
          <div class="p-10">
            <div class="m-t-20 font-32 font-weight-500 cor-00">个人信息</div>
            <van-cell-group class="m-t-20">
              <van-field v-model="formData.deptId" :rules="[{required:true,message:'部门不能为空'}]" :required="true"
                         name="flowName" label="部门" placeholder="部门" input-align="right">
                <template #input>
                  <view-item @click.native="deptId.show = true" :tree-data="deptId.data" :value="formData.deptId"
                             placeholder="请选择部门"/>
                  <van-popup position="bottom" v-model="deptId.show">
                    <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="deptId.show = false"
                                 @click-right="handlePopupSubmit"/>
                    <van-search v-model="deptId.filterText" @input="treeSearch($event, $refs.ocr_dept_tree)" clearable
                                shape="round"/>
                    <div style="overflow-y: auto" class="h-vh-35">
                      <div class="p-10">
                        <el-tree ref="ocr_dept_tree" @check-change="singleChoice($event,$refs.ocr_dept_tree)"
                                 node-key="id" check-strictly :data="deptId.data" :filter-node-method="filterNode"
                                 check-on-click-node show-checkbox/>
                      </div>
                    </div>
                  </van-popup>
                </template>
              </van-field>
            </van-cell-group>
            <div class="m-t-20 font-32 font-weight-500 cor-00">发票信息</div>
            <van-cell-group class="m-t-20" v-if="formData.invoiceType == 3">
              <van-field input-align="right" name="invoiceType" :rules="[{required:true,message:'发票类型不能为空'}]"
                         :required="true" :value="formData.invoiceType" label="发票类型" placeholder="请选择发票类型">
                <template #input>
                  <view-item @click.native="invoiceType.show = true" :value="formData.invoiceTypeName"
                             placeholder="请选择发票类型"/>
                  <van-popup v-model="invoiceType.show" position="bottom">
                    <van-nav-bar title="选择发票类型" left-text="取消" right-text="确定"
                                 @click-left="invoiceType.show = false"
                                 @click-right="popupSubmit('invoiceType',{label:'dictLable',value:'dictValue'})"/>
                    <van-picker ref="invoiceType" value-key="dictLabel" :columns="invoiceType.data"
                                @cancel="invoiceType.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field input-align="right" name="invoiceTitle" :rules="[{required:true,message:'发票抬头不能为空'}]"
                         :required="true" :value="formData.invoiceTitle" label="发票抬头" placeholder="请选择发票抬头">
                <template #input>
                  <view-item @click.native="invoiceTitle.show = true" :value="formData.invoiceTitle"
                             placeholder="请选择发票抬头"/>
                  <van-popup v-model="invoiceTitle.show" position="bottom">
                    <van-nav-bar title="选择发票抬头" left-text="取消" right-text="确定"
                                 @click-left="invoiceTitle.show = false" @click-right="popupSubmit('invoiceTitle')"/>
                    <van-search v-model="invoiceTitle.filterText" @input="pickerSearch($event,invoiceTitle,'unitName')"
                                clearable shape="round"/>
                    <van-picker ref="invoiceTitle" value-key="unitName" :columns="invoiceTitle.filteredData"
                                @cancel="invoiceTitle.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field v-model="formData.buyerTax"
                         :rules="formRules.buyerTax" name="buyerTax" :required="true"
                         :maxlength="20" placeholder="请输入纳税人识别号" label="纳税人识别号" input-align="right"></van-field>
              <van-field v-model="formData.invoiceCode" type="number"
                         :rules="[{required:true,message:'发票号码不能为空'}]" name="invoiceCode" :required="true"
                         :maxlength="20" placeholder="请输入发票号码" label="发票号码" input-align="right"></van-field>
              <van-field v-model="formData.invoiceDate" :rules="[{required:true,message:'开票日期不能为空'}]"
                         :required="true" name="invoiceDate" label="开票日期" placeholder="开票日期"
                         input-align="right">
                <template #input>
                  <view-item @click.native="invoiceDate.show = true" :value="formData.invoiceDate"
                             placeholder="请选择开票日期"/>
                  <van-calendar v-model="invoiceDate.show" :min-date="invoiceDate.minDate" ref="invoiceDate"
                                :show-confirm="false" title="选择开票日期" @confirm="invoiceDateConfirm"></van-calendar>
                </template>
              </van-field>
              <van-field input-align="right" name="isElectronic" :rules="[{required:true,message:'不能为空'}]"
                         :required="true" :value="formData.isElectronic" label="是否电子票"
                         placeholder="请选择是否电子票">
                <template #input>
                  <view-item @click.native="isElectronic.show = true" :value="formData.isElectronicName"
                             placeholder="请选择是否电子票"/>
                  <van-popup v-model="isElectronic.show" position="bottom">
                    <van-nav-bar title="选择是否电子票" left-text="取消" right-text="确定"
                                 @click-left="isElectronic.show = false"
                                 @click-right="popupSubmit('isElectronic',{label:'dictLable',value:'dictValue'})"/>
                    <van-picker ref="isElectronic" value-key="dictLabel" :columns="isElectronic.data"
                                @cancel="isElectronic.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field v-model="formData.ticketPrice" type="number" name="ticketPrice"
                         :rules="[{required:true,message:'金额不能为空'}]" :required="true" :maxlength="20"
                         placeholder="请输入金额" label="金额" input-align="right"></van-field>
              <van-field v-model="formData.travelInformation" :required="true" name="travelInformation" type="textarea" maxlength="100"
                         rows="3" :rules="[{required:true,message:'行程信息不能为空'}]" autosize label="行程信息"
                         show-word-limit placeholder="请输入行程信息" input-align="right"/>
              <van-field v-model="formData.travelTime" :rules="[{required:true,message:'乘车时间不能为空'}]"
                         :required="true" name="travelTime" label="乘车时间" placeholder="乘车时间"
                         input-align="right">
                <template #input>
                  <view-item @click.native="travelTime.show = true" :value="formData.travelTime"
                             placeholder="请选择乘车时间"/>
                  <van-calendar v-model="travelTime.show" :min-date="travelTime.minDate" ref="travelTime"
                                :show-confirm="false" title="选择乘车时间" @confirm="travelTimeConfirm"></van-calendar>
                </template>
              </van-field>
              <van-field v-model="formData.passenger"
                         :rules="[{required:true,message:'乘车人不能为空'}]" name="passenger" :required="true"
                         :maxlength="20" placeholder="请输入乘车人" label="乘车人" input-align="right"></van-field>
            </van-cell-group>
              <!-- 航空电子行程单表单区域 -->
            <van-cell-group class="m-t-20" v-else-if="formData.invoiceType ==4">
              <van-field input-align="right" name="invoiceType" :rules="[{required:true,message:'发票类型不能为空'}]"
                         :required="true" :value="formData.invoiceType" label="发票类型" placeholder="请选择发票类型">
                <template #input>
                  <view-item @click.native="invoiceType.show = true" :value="formData.invoiceTypeName"
                             placeholder="请选择发票类型"/>
                  <van-popup v-model="invoiceType.show" position="bottom">
                    <van-nav-bar title="选择发票类型" left-text="取消" right-text="确定"
                                 @click-left="invoiceType.show = false"
                                 @click-right="popupSubmit('invoiceType',{label:'dictLable',value:'dictValue'})"/>
                    <van-picker ref="invoiceType" value-key="dictLabel" :columns="invoiceType.data"
                                @cancel="invoiceType.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field input-align="right" name="invoiceTitle" :rules="[{required:true,message:'发票抬头不能为空'}]"
                         :required="true" :value="formData.invoiceTitle" label="发票抬头" placeholder="请选择发票抬头">
                <template #input>
                  <view-item @click.native="invoiceTitle.show = true" :value="formData.invoiceTitle"
                             placeholder="请选择发票抬头"/>
                  <van-popup v-model="invoiceTitle.show" position="bottom">
                    <van-nav-bar title="选择发票抬头" left-text="取消" right-text="确定"
                                 @click-left="invoiceTitle.show = false" @click-right="popupSubmit('invoiceTitle')"/>
                    <van-search v-model="invoiceTitle.filterText" @input="pickerSearch($event,invoiceTitle,'unitName')"
                                clearable shape="round"/>
                    <van-picker ref="invoiceTitle" value-key="unitName" :columns="invoiceTitle.filteredData"
                                @cancel="invoiceTitle.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field v-model="formData.buyerTax"
                         :rules="formRules.buyerTax" name="buyerTax" :required="true"
                         :maxlength="20" placeholder="请输入纳税人识别号" label="纳税人识别号" input-align="right"></van-field>
              <van-field v-model="formData.invoiceCode" type="number"
                         :rules="[{required:true,message:'发票号码不能为空'}]" name="invoiceCode" :required="true"
                         :maxlength="20" placeholder="请输入发票号码" label="发票号码" input-align="right"></van-field>
              <van-field v-model="formData.invoiceDate" :rules="[{required:true,message:'开票日期不能为空'}]"
                         :required="true" name="invoiceDate" label="开票日期" placeholder="开票日期"
                         input-align="right">
                <template #input>
                  <view-item @click.native="invoiceDate.show = true" :value="formData.invoiceDate"
                             placeholder="请选择开票日期"/>
                  <van-calendar v-model="invoiceDate.show" :min-date="invoiceDate.minDate" ref="invoiceDate"
                                :show-confirm="false" title="选择开票日期" @confirm="invoiceDateConfirm"></van-calendar>
                </template>
              </van-field>
              <van-field input-align="right" name="isElectronic" :rules="[{required:true,message:'不能为空'}]"
                         :required="true" :value="formData.isElectronic" label="是否电子票"
                         placeholder="请选择是否电子票">
                <template #input>
                  <view-item @click.native="isElectronic.show = true" :value="formData.isElectronicName"
                             placeholder="请选择是否电子票"/>
                  <van-popup v-model="isElectronic.show" position="bottom">
                    <van-nav-bar title="选择是否电子票" left-text="取消" right-text="确定"
                                 @click-left="isElectronic.show = false"
                                 @click-right="popupSubmit('isElectronic',{label:'dictLable',value:'dictValue'})"/>
                    <van-picker ref="isElectronic" value-key="dictLabel" :columns="isElectronic.data"
                                @cancel="isElectronic.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field v-model="formData.ticketPrice" type="number" name="ticketPrice"
                         :rules="[{required:true,message:'机票金额不能为空'}]" :required="true" :maxlength="20"
                         placeholder="请输入机票金额" label="机票金额" input-align="right"></van-field>
              <van-field v-model="formData.fuelFee" type="number" name="fuelFee"
                         :rules="[{required:true,message:'燃油附加费不能为空'}]" :required="true" :maxlength="20"
                         placeholder="请输入燃油附加费" label="燃油附加费" input-align="right"></van-field>
              <van-field v-model="formData.civilFund" type="number" name="civilFund"
                         :rules="[{required:true,message:'民航发展基金不能为空'}]" :required="true" :maxlength="20"
                         placeholder="请输入民航发展基金" label="民航发展基金" input-align="right"></van-field>
              <van-field v-model="formData.invoiceAmount" type="number" name="invoiceAmount"
                         :rules="[{required:true,message:'合计金额不能为空'}]" :required="true" :maxlength="20"
                         placeholder="请输入合计金额" label="合计金额" input-align="right"></van-field>           
              <van-field v-model="formData.taxRate" type="number" name="taxRate"
                         :rules="[{required:true,message:'增值税税率不能为空'}]" :required="true" :maxlength="20"
                         placeholder="请输入增值税税率" label="增值税税率" input-align="right"></van-field>   
              <van-field v-model="formData.taxAmount"  name="taxAmount"
                         :rules="[{required:true,message:'增值税税额不能为空'}]" :required="true" :maxlength="20"
                         placeholder="请输入增值税税额" label="增值税税额" input-align="right"></van-field>
              <van-field v-model="formData.otherFees" type="number" name="otherFees"
                         :rules="[{required:false,message:'其他税费不能为空'}]" :required="false" :maxlength="20"
                         placeholder="请输入其他税费" label="其他税费" input-align="right"></van-field>
              <van-field v-model="formData.seller" :rules="[{required:true,message:'填开单位不能为空'}]"
                         :required="true" name="seller" placeholder="请输入填开单位" label="填开单位" 
                         input-align="right"></van-field>
              <van-field v-model="formData.passenger" :rules="[{required:true,message:'乘机人不能为空'}]"
                         :required="true" name="passenger" placeholder="请输入乘机人姓名" label="乘机人" 
                         input-align="right"></van-field>
              <van-field v-model="formData.departureStation" :rules="[{required:true,message:'出发城市不能为空'}]"
                         :required="true" name="departureStation" placeholder="请输入出发城市" label="出发城市" 
                         input-align="right"></van-field>
              <van-field v-model="formData.arriveStation" :rules="[{required:true,message:'到达城市不能为空'}]"
                         :required="true" name="arriveStation" placeholder="请输入到达城市" label="到达城市" 
                         input-align="right"></van-field>
               <!--<van-field v-model="formData.flightNumber" :rules="[{required:false,message:'航班号不能为空'}]"
                         :required="false" name="flightNumber" placeholder="请输入航班号" label="航班号" 
                         input-align="right"></van-field>
              <van-field v-model="formData.cabinClass" name="cabinClass" placeholder="请输入舱位等级" label="舱位等级" 
                         input-align="right"></van-field> -->
            </van-cell-group>
            <van-cell-group class="m-t-20" v-else>
              <van-field input-align="right" name="invoiceType" :rules="[{required:true,message:'发票类型不能为空'}]"
                         :required="true" :value="formData.invoiceType" label="发票类型" placeholder="请选择发票类型">
                <template #input>
                  <view-item @click.native="invoiceType.show = true" :value="formData.invoiceTypeName"
                             placeholder="请选择发票类型"/>
                  <van-popup v-model="invoiceType.show" position="bottom">
                    <van-nav-bar title="选择发票类型" left-text="取消" right-text="确定"
                                 @click-left="invoiceType.show = false"
                                 @click-right="popupSubmit('invoiceType',{label:'dictLable',value:'dictValue'})"/>
                    <van-picker ref="invoiceType" value-key="dictLabel" :columns="invoiceType.data"
                                @cancel="invoiceType.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field input-align="right" name="invoiceTitle" :rules="[{required:true,message:'发票抬头不能为空'}]"
                         :required="true" :value="formData.invoiceTitle" label="发票抬头" placeholder="请选择发票抬头">
                <template #input>
                  <view-item @click.native="invoiceTitle.show = true" :value="formData.invoiceTitle"
                             placeholder="请选择发票抬头"/>
                  <van-popup v-model="invoiceTitle.show" position="bottom">
                    <van-nav-bar title="选择发票抬头" left-text="取消" right-text="确定"
                                 @click-left="invoiceTitle.show = false" @click-right="popupSubmit('invoiceTitle')"/>
                    <van-search v-model="invoiceTitle.filterText" @input="pickerSearch($event,invoiceTitle,'unitName')"
                                clearable shape="round"/>
                    <van-picker ref="invoiceTitle" value-key="unitName" :columns="invoiceTitle.filteredData"
                                @cancel="invoiceTitle.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field v-model="formData.buyerTax"
                         :rules="formRules.buyerTax" name="buyerTax" :required="true"
                         :maxlength="20" placeholder="请输入纳税人识别号" label="纳税人识别号" input-align="right"></van-field>
              <van-field v-model="formData.invoiceCode" type="number"
                         :rules="[{required:true,message:'发票号码不能为空'}]" name="invoiceCode" :required="true"
                         :maxlength="20" placeholder="请输入发票号码" label="发票号码" input-align="right"></van-field>
              <van-field v-model="formData.invoiceDate" :rules="[{required:true,message:'开票日期不能为空'}]"
                         :required="true" name="invoiceDate" label="开票日期" placeholder="开票日期"
                         input-align="right">
                <template #input>
                  <view-item @click.native="invoiceDate.show = true" :value="formData.invoiceDate"
                             placeholder="请选择开票日期"/>
                  <van-calendar v-model="invoiceDate.show" :min-date="invoiceDate.minDate" ref="invoiceDate"
                                :show-confirm="false" title="选择开票日期" @confirm="invoiceDateConfirm"></van-calendar>
                </template>
              </van-field>
              <van-field input-align="right" name="isElectronic" :rules="[{required:true,message:'不能为空'}]"
                         :required="true" :value="formData.isElectronic" label="是否电子票"
                         placeholder="请选择是否电子票">
                <template #input>
                  <view-item @click.native="isElectronic.show = true" :value="formData.isElectronicName"
                             placeholder="请选择是否电子票"/>
                  <van-popup v-model="isElectronic.show" position="bottom">
                    <van-nav-bar title="选择是否电子票" left-text="取消" right-text="确定"
                                 @click-left="isElectronic.show = false"
                                 @click-right="popupSubmit('isElectronic',{label:'dictLable',value:'dictValue'})"/>
                    <van-picker ref="isElectronic" value-key="dictLabel" :columns="isElectronic.data"
                                @cancel="isElectronic.show = false"/>
                  </van-popup>
                </template>
              </van-field>
              <van-field v-model="formData.invoiceAmount" type="number" name="invoiceAmount"
                         :rules="[{required:true,message:'价税合计金额不能为空'}]" :required="true" :maxlength="20"
                         placeholder="价税合计金额" label="价税合计金额" input-align="right"></van-field>
              <van-field v-model="formData.taxAmount" type="number" name="taxAmount" :required="true" :maxlength="20"
                         :rules="[{required:true,message:'税额不能为空'}]" placeholder="税额" label="税额"
                         input-align="right"></van-field>
              <van-field v-model="formData.taxExcludedAmount" type="number" name="taxExcludedAmount" :required="true"
                         :rules="[{required:true,message:'不含税金额不能为空'}]" :maxlength="20"
                         placeholder="不含税金额" label="不含税金额" input-align="right"></van-field>
              <van-field v-model="formData.taxRate" type="number" name="taxRate" :required="true" :maxlength="20"
                         :rules="[{required:true,message:'税率不能为空'}]" placeholder="请输入税率" label="税率%"
                         input-align="right"></van-field>
              <van-field v-model="formData.seller" :required="true" name="seller" type="textarea" maxlength="200"
                         rows="3" :rules="[{required:true,message:'销售方名称不能为空'}]" autosize label="销售方名称"
                         show-word-limit placeholder="请输入销售方名称" input-align="right"/>
            </van-cell-group>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
import {mapState} from "vuex";
import {upLoadFile} from "@/api/file";
import axios from "axios";
import {invoiceCollection} from '@/utils/invoiceOCR'
import {invoice, fmInvoice_page, judgeExistsFmInvoice} from '@/api/invoice'
import { IdentifyObjs } from "@/utils/OCRElement.js"
import {getCurrentUserDept} from "@/api/user";
import cache from "@/plugins/cache";
import {deptTree} from '@/api/user'
import {ImagePreview} from 'vant';
import {getDictDataByType} from "@/api/dict";
import PdfPreview from '@/components/PdfPreview/index.vue'; // 引入上述组件
const OCR_url = 'https://ocr.nmgheli.com/upload'

export default {
  components: { PdfPreview },
  name: 'invoice',
  props: {
    processInstanceId: {
      type: String,
    },
    show: {
      type: Boolean,
      default: false
    },
    groupId: {
      type: String,
    },
  },
  computed: {
    ...mapState({
      image_base_url: state => state.settings.image_base_url,
    })
  },
  data() {
    return {
      moment,
      // 文件对象
      file: null,
      // PDF预览链接
      pdfSrc: '',
      // PDF加载错误标识
      pdfLoadError: false,
      invoiceType: {
        data: [],
        show: false,
      },
      isElectronic: {
        data: [{dictValue: 'Y', dictLabel: '是'}, {dictValue: 'N', dictLabel: '否'}],
        show: false,
      },
      // 用印日期
      invoiceDate: {
        show: false,
        minDate: new Date(2020, 0, 1),
      },
      travelTime: {
        show: false,
        minDate: new Date(2020, 0, 1),
      },
      formData: {
        deptId: '',
        // 发票类型 普票1 专票0 火车票3 航空电子行程4
        invoiceType: '',
        invoiceTypeName: '',
        // 发票抬头
        invoiceTitle: '',
        // 是否电子票
        isElectronic: '',
        isElectronicName: '',
        // 发票号码
        invoiceCode: '',
        // 开票日期
        invoiceDate: '',
        // 税额
        taxAmount: '',
        // 不含税金额
        taxExcludedAmount: '',
        // 价税合计金额
        invoiceAmount: '',
        // 销售方名称
        seller: '',
        // 税率
        taxRate: '',
        // 火车票专属字段
        ticketPrice: '',
        travelInformation: '',
        travelTime: '',
        passenger: '',
        // 航空电子行程单专属字段
        departureCity: '', // 出发城市
        arrivalCity: '', // 到达城市
        flightNumber: '', // 航班号
        flightDate: '', // 航班日期
        passenger: '', // 乘机人
        cabinClass: '', // 舱位等级
        // 共用字段
        buyerTax: '' // 纳税人识别号
      },
      formRules: {
        buyerTax: [
          {
            required: true,
            trigger: 'change',
            validator: (value, rule) => {
              return new Promise((resolve, reject) => {
                judgeExistsFmInvoice({
                  unitName: this.formData.invoiceTitle,
                  identifierNumber: value
                })
                    .then(res => {
                      if (!res.data.isExist) {
                        reject(new Error('购买方纳税人识别号与公司登记信息不一致，请核对发票内容！'));
                        this.$toast({message: '购买方纳税人识别号与公司登记信息不一致，请核对发票内容！', position: 'bottom'})
                      } else {
                        resolve();
                      }
                    })
                    .catch(err => {
                      console.error('校验纳税人识别号时出错:', err);
                      this.$toast({message: '校验纳税人识别号时出错，请稍后重试！', position: 'bottom'})
                      reject(new Error('校验纳税人识别号时出错，请稍后重试！'));
                    });
              });
            }
          }
        ],
      },
      deptId: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      invoiceTitle: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      imageFileList: [],
      refreshing: false,
      error: false,
    }
  },
  created() {
    getDictDataByType('invoice_type').then(res => {
      this.invoiceType.data = res.data
    })

    const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
    this.getCurrentUserDept(currentUserInfo)
    fmInvoice_page({pageNum: 1, pageSize: 10000}).then(res => {
      this.invoiceTitle.data = res.rows
      this.invoiceTitle.filteredData = res.rows
    })
  },
  methods: {
// 航班日期确认
    flightDateConfirm(date) {
      this.formData.flightDate = moment(date).format('YYYY-MM-DD')
      this.flightDate.show = false
    },
    invoiceDateConfirm(date) {
      this.formData.invoiceDate = moment(date).format('YYYY-MM-DD')
      this.invoiceDate.show = false
    },
    travelTimeConfirm(date) {
      this.formData.travelTime = moment(date).format('YYYY-MM-DD')
      this.travelTime.show = false
    },
    /**
     * 全局picker组件的搜索逻辑
     * @param text
     * @param deploy 数据源和用于展示的过滤数据源
     * @param key 搜索的key
     */
    pickerSearch(text, deploy, key) {
      deploy.filteredData = deploy.data.filter(item => {
        return key ? item[key].indexOf(text) !== -1 : item.indexOf(text) !== -1
      })
    },
    // picker弹窗确认
    popupSubmit(field, props) {
      const item = this.$refs[field].getValues()[0]
      this.$set(this[field], 'show', false)

      if (!props) {
        console.warn('没传props配置项，直接全量赋值')
        this.$set(this.formData, field, typeof item === 'object' ? item.unitName : item)
        return
      }
      this.$set(this.formData, field, item.dictValue)
      this.formData[field + 'Name'] = item.dictLabel
    },
    previewImage(file, a) {
      ImagePreview({
        images: [file],
        startPosition: 0,
      });
    },
    // 部门弹窗确认
    handlePopupSubmit() {
      if (this.$refs.ocr_dept_tree.getCheckedNodes().length <= 0) {
        this.$toast({message: '请至少选择一项', position: 'bottom'})
        return
      }
      this.formData.deptId = this.$refs.ocr_dept_tree.getCheckedNodes()[0].id
      this.deptId.show = false
    },
    // 过滤节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 用于管理动态table中的treeSearch
    treeSearch(text, treeDom) {
      let dom = treeDom.length ? treeDom[0] : treeDom
      dom.filter(text);
    },
    // 单选
    singleChoice(event, dom) {
      if (dom.length) {
        dom = dom[0]
      }
      const len = dom.getCheckedNodes().length
      if (len > 1) {
        dom.setCheckedKeys([])
        dom.setCheckedNodes([event])
      }
    },
    // 保存并关闭
    relativeFlowPopupSubmit() {
      
      // console.log('relativeFlowPopupSubmit',this.file)
      this.$refs.form.validate().then(success => {
        this.$loading.show()
        const params = {invoiceCode: this.formData.invoiceCode, instanceId: this.processInstanceId, comeFrom: 1}
        invoice(params).then(res => {
          const file = {
            id: this.file.id,
            fileName: this.file.name,
            filePath:this.file.servletRequestUrl+ this.file.previewUrl,
            fileType: this.file.fileType,
            fileSize: this.file.fileSize
          }
          const data = {
            ...this.formData,
            file
          }
          console.log('relativeFlowPopupSubmit',data)
          this.$emit('success', data)
          this.$loading.hide()
        }).catch(err => {
          this.$loading.hide()
        })
      }).catch(err => {
        console.log(err)
      })
    },
    close() {
    this.clearForm()
      this.$emit('close')
    },
    //清除表单
    clearForm(){
     this.file = null;
      this.pdfSrc = ''; // 清空PDF预览链接
      this.pdfLoadError = false; // 重置错误状态
      this.formData = {
       deptId: '',
        invoiceType: '',
        invoiceTypeName: '',
        invoiceTitle: '',
        isElectronic: '',
        isElectronicName: '',
        invoiceCode: '',
        invoiceDate: '',
        taxAmount: '',
        taxExcludedAmount: '',
        invoiceAmount: '',
        seller: '',
        taxRate: '',
        // 火车票字段
        ticketPrice: '',
        travelInformation: '',
        travelTime: '',
        passenger: '',
        // 航空行程单字段
        departureCity: '',
        arrivalCity: '',
        flightNumber: '',
        flightDate: '',
        passenger: '',
        cabinClass: '',
        // 共用字段
        buyerTax: ''
      }
    
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        deptTree().then(res => {
          this.deptId.data = res.data
          this.deptId.filteredData = this.deptId.data
          resolve(res.data)
        })
      })
    },
    // 文件上传前校验
    beforeRead(file) {
      // 双重校验：文件类型+后缀名，彻底杜绝非PDF文件
      const allowedTypes = ['application/pdf', 'application/x-pdf'];
      const allowedExtensions = ['pdf'];
      
      // 处理单文件/多文件（此处multiple=false，仅单文件）
      const checkFile = (item) => {
        // 校验文件类型
        const typeValid = allowedTypes.some(type => item.type.toLowerCase().includes(type));
        // 校验文件后缀（避免类型伪造）
        const ext = item.name.split('.').pop().toLowerCase();
        const extValid = allowedExtensions.includes(ext);
        
        if (!typeValid || !extValid) {
          this.$toast('只能上传PDF格式的发票文件');
          return false;
        }
        return true;
      };

      if (Array.isArray(file)) {
        return file.every(checkFile);
      } else {
        return checkFile(file);
      }
    },
    // 文件上传后处理
    async afterAddFile(files) {
      // 再次验证文件类型以确保安全
      if (files.file.type !== 'application/pdf' && !files.file.name.toLowerCase().endsWith('.pdf')) {
        this.$toast('只能上传PDF格式文件');
        return;
      }
      this.$loading.show()
      try {
        const file = await this.upLoadFile(files)
        this.file = file
        // 关键：拼接完整的PDF预览地址，确保返回Content-Type为application/pdf
        this.pdfSrc =file.servletRequestUrl+ file.previewUrl; 
        this.$nextTick(()=>{
          this.$refs['PdfPreview'].initPdfjs();
          this.$refs['PdfPreview'].resetPDF()
          this.$refs['PdfPreview'].loadPDF();
        })
        const result = await this.OCR_file(files)
        let fromTofile = {
          ...this.form,
          ...this.convertToForm(result),
        };
        // 对象合并
        this.formData = Object.assign(this.formData, fromTofile)
        
        this.formData.invoiceDate = this.formatDate(fromTofile.invoiceDate); // 开票日期
        this.formData.isElectronic = 'Y'; // 是否电子票
        this.formData.isElectronicName = '是'; // 是否电子票
        this.formData.invoiceTitleId = this.buyerMatching(fromTofile.buyer) // 发票抬头id
        this.formData.unitName = fromTofile.buyer // 发票抬头
        this.formData.invoiceTypeName = this.invoiceTypeOR(fromTofile.invoiceType) // 发票类型
        this.$set(this.formData, 'invoiceTitle', fromTofile.buyer) // 发票抬头

        if (this.formData.invoiceType == 3) { // 判断是否是火车票
          this.$set(this.formData, 'travelInformation', fromTofile.departureStation && fromTofile.arriveStation ? fromTofile.departureStation + '——' + fromTofile.arriveStation : '')
          this.$set(this.formData, 'travelTime', fromTofile.travelTime ? this.formatDate(fromTofile.travelTime) : '')
        } 
         // 航空电子行程单逻辑
        else if (this.formData.invoiceType ==4) {
          // 映射航空行程单OCR识别字段
          this.formData.departureCity = fromTofile.departureCity || fromTofile.departureStation || ''
          this.formData.arrivalCity = fromTofile.arrivalCity || fromTofile.arriveStation || ''
          this.formData.flightNumber = fromTofile.flightNumber || fromTofile.flightNo || ''
          this.formData.flightDate = fromTofile.flightDate ? this.formatDate(fromTofile.flightDate) : ''
          this.formData.passenger = fromTofile.passenger || fromTofile.passenger || ''
          this.formData.cabinClass = fromTofile.cabinClass || fromTofile.seatClass || ''
          this.formData.ticketPrice = fromTofile.ticketPrice || fromTofile.amount || ''
        }
        else {
          this.formData.taxRate = this.taxRate(fromTofile.taxRate);
          // fromTofile.taxAmount 如果包含*号，需要去掉
          if (fromTofile.taxAmount && fromTofile.taxAmount.includes('*')) { 
            this.formData.taxAmount = 0 // 税额
          }
        }
        this.$loading.hide()
      } catch (err) {
        console.error(err)
        this.$loading.hide()
      }
    },
    // 转换OCR数据为表单格式
    convertToForm(datas) {
      console.log('datas', datas)
      var form = {}
      datas.forEach(item => {
        if (item.enName == 'entryName' || item.enName == 'serviceName') {
          // 将数组中的值拼接成字符串
          form[item.enName] = item.value.join(';')
        } else {
          if (typeof item.value == 'string') {
            form[item.enName] = item.value
          } else {
            if (item.value.content) {
              form[item.enName] = item.value.content
            } else {
              form[item.enName] = item.value[0]
            }
          }
        }
      })
      // 补充航空行程单字段兼容映射
      if (form.invoiceType === '航空电子行程单' || form.invoiceType === '4') {
        form.invoiceType = '4'
      }
      return form
    },
    // OCR识别文件
    OCR_file(fileItem) {
      const formData = new FormData()
      formData.append('file', fileItem.file);
      return new Promise((resolve, reject) => {
        axios.post(OCR_url, formData).then(res => {
          let i = new IdentifyObjs();
          const datas = res.data;
          let r = i.analysisDatas(datas);
          const result = r[0]
          resolve(result)
        }).catch(err => {
          reject('ocr,err', err)
        })
      })
    },
    // 格式化日期
    formatDate(dateString) {
        if (!dateString) return ''
      // 兼容多种日期格式：2024年05月20日、2024-05-20、2024/05/20
      const regex1 = /^(\d{4})年(\d{2})月(\d{2})日$/;
      const regex2 = /^(\d{4})[-/](\d{2})[-/](\d{2})$/;
      
      const matches1 = regex1.exec(dateString);
      if (matches1) {
        return `${matches1[1]}-${matches1[2]}-${matches1[3]}`;
      }
      
      const matches2 = regex2.exec(dateString);
      if (matches2) {
        return `${matches2[1]}-${matches2[2]}-${matches2[3]}`;
      }
      
      return dateString;
    },
    // 匹配发票抬头ID
    buyerMatching(buyer) {
      return this.invoiceTitle.data.find(item => item.unitName.includes(buyer))?.id
    },
    // 匹配发票类型名称
    invoiceTypeOR(invoiceType) {
      if(!invoiceType) return ''
      return this.invoiceType.data.find(item => item.dictValue.includes(invoiceType))?.dictLabel
    },
    // 处理税率格式
    taxRate(taxRate) {
      // 判断是否包含百分号
      if (taxRate.includes("%")) {
        // 去掉百分号
        taxRate = Number(taxRate.slice(0, -1));
      }else{
        // 不是百分比，直接返回
        return 0;
      }
      return taxRate;
    },
    // 上传文件到服务器
    upLoadFile(fileItem) {
      const processedFile = this.processFileName(fileItem.file);
      let FormDatas = new FormData();
      FormDatas.append('file',processedFile);
      return new Promise((resolve, reject) => {
        upLoadFile(FormDatas).then(res => {
          Object.assign(fileItem, res.data)
          resolve(fileItem)
        }).catch(err => {
          reject(err)
        });
      })
    },
        // 处理文件名特殊字符（保留原逻辑，对后端友好）
    processFileName(file) {
      if (!file || !file.name) return file;
      const nameParts = file.name.split(".");
      const extension = nameParts.length > 1 ? "." + nameParts.pop() : "";
      const baseName = nameParts.join(".");
      const processedBaseName = this.sanitizeFileName(baseName);
      const processedFileName = processedBaseName + extension;
      // 重新创建File对象，修改文件名
      return new File([file], processedFileName, {
        type: file.type,
        lastModified: file.lastModified
      });
    },

    // 清理文件名特殊字符（保留原逻辑）
    sanitizeFileName(fileName) {
      if (!fileName) return fileName;
      const replacements = {
        "(": "_",
        ")": "_",
        "[": "_",
        "]": "_",
        "+": "_",
        " ": "_",
        "#": "_",
        "%": "_",
        "&": "_",
        "=": "_",
        "<": "_",
        ">": "_",
        "{": "_",
        "}": "_",
        "|": "_",
        "\\": "_",
        "^": "_",
        "`": "_",
        "~": "_",
        "*": "_",
        "?": "_",
        '"': "'",
        ":": "-",
        ";": ","
      };
      let processedName = fileName;
      for (const [char, replacement] of Object.entries(replacements)) {
        const regex = new RegExp(this.escapeRegExp(char), "g");
        processedName = processedName.replace(regex, replacement);
      }
      // 移除连续下划线、首尾下划线/连字符
      processedName = processedName.replace(/_+/g, "_").replace(/^[_\-]+|[_\-]+$/g, "");
      return processedName;
    },

    // 正则特殊字符转义（保留原逻辑）
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
  }
}
</script>

<style lang="less" scoped>
.pdfBox {
  max-height: 30vh;
  padding:10px;
  overflow: auto;
  touch-action: pan-y; /* 允许垂直滚动，阻止其他触摸动作干扰 */
  /* 移动端触摸优化 */
  -webkit-overflow-scrolling: touch;
}

.activated {
  border: 1px solid @theme-color;
}

.Muploader{
  /deep/ input[type="file"] {
    /* 华为浏览器原生input的相机图标隐藏 */
    &::-webkit-file-upload-button {
      visibility: hidden;
    }
    /* 禁止浏览器添加额外操作按钮 */
    &::file-selector-button {
      display: none;
    }
  }
  /* 确保van-uploader内部无冗余图标 */
  /deep/ .van-uploader__input-wrapper {
    background: transparent;
    border: none;
  }
}

</style>